import styled from 'styled-components/native'

export const QuestionTextContainer = styled.View``

export const StoryContainer = styled.View`
  background-color: gray;
  height: 100%;
  width: 100%;
`
